import React, { useState } from 'react';
import styled from 'styled-components';
import { FaSearch } from 'react-icons/fa';
import CustomCalendar from './CustomCalendar';

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0.25rem 0.75rem;
  margin: 0.5rem 0;
  position: relative;
  justify-content: space-between;
  border: 1px solid #ddd; /* Add border */
`;

const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding: 0 0.75rem;
  border-right: 1px solid #ddd; /* Add separator between all inputs */
  &:last-of-type {
    border-right: none; /* Remove separator for the last input */
  }
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  width: 100%;
`;

const SearchButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0.75rem;
`;

const SearchButton = styled.button`
  background-color: #007bff;
  border: none;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #0056b3;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const CalendarContainer = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
`;

const SearchBar = () => {
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [selectedDates, setSelectedDates] = useState({ start: null, end: null });

  const handleDateSelect = (dates) => {
    setSelectedDates(dates);
    setCalendarOpen(false);
  };

  const closeCalendar = () => {
    setCalendarOpen(false);
  };

  const formatDates = () => {
    const { start, end } = selectedDates;
    if (start && end) {
      return `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
    }
    return '';
  };

  return (
    <>
      <SearchContainer>
        <SearchInputWrapper>
          <SearchInput type="text" placeholder="Where" />
        </SearchInputWrapper>
        <SearchInputWrapper>
          <SearchInput
            type="text"
            placeholder="Check-in - Check-out"
            onFocus={() => setCalendarOpen(true)}
            value={formatDates()}
            readOnly
          />
        </SearchInputWrapper>
        <SearchInputWrapper style={{ borderRight: 'none' }}>
          <SearchInput type="text" placeholder="Occupants" />
        </SearchInputWrapper>
        <SearchButtonWrapper>
          <SearchButton>
            <FaSearch />
            Search
          </SearchButton>
        </SearchButtonWrapper>
      </SearchContainer>
      {calendarOpen && (
        <Overlay onClick={closeCalendar}>
          <CalendarContainer onClick={(e) => e.stopPropagation()}>
            <CustomCalendar
              onDateSelect={handleDateSelect}
              selectedDates={selectedDates}
              setSelectedDates={setSelectedDates}
            />
          </CalendarContainer>
        </Overlay>
      )}
    </>
  );
};

export default SearchBar;
